import {MatrixClient} from 'matrix-js-sdk';

export const getMatrixUserName = async (
  client: MatrixClient,
  userId: string
): Promise<string | null> => {
  try {
    const profileInfo = await client.getProfileInfo(userId);
    return profileInfo.displayname || null;
  } catch (error) {
    console.error('Error fetching Matrix user profile:', error);
    return null;
  }
};
